import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=4b149f24&scoped=true"
import script from "./optional.vue?vue&type=script&lang=js"
export * from "./optional.vue?vue&type=script&lang=js"
import style0 from "./optional.vue?vue&type=style&index=0&id=4b149f24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b149f24",
  null
  
)

export default component.exports